import { render } from "./DatasourceMetaDataFull.vue?vue&type=template&id=a0b53c2e&scoped=true&ts=true"
import script from "./DatasourceMetaDataFull.vue?vue&type=script&lang=ts"
export * from "./DatasourceMetaDataFull.vue?vue&type=script&lang=ts"

import "./DatasourceMetaDataFull.vue?vue&type=style&index=0&id=a0b53c2e&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0b53c2e"]])

export default __exports__